import RichText from "@/components/RichText"
import { cn } from "@/lib/utils"
import { createDataAttribute, PortableTextBlock } from "next-sanity"

interface StatementTextProps {
  text: PortableTextBlock[]
  index: number
	documentId: string
	_key: string
}

export default function StatementText({text, index, documentId, _key}:StatementTextProps) {
	return (
		<div
			className="section px-site"
			key={_key}
			data-sanity={createDataAttribute({
				id: documentId,
				type: 'project',
				path: `contentBlocks[_key=="${_key}"]`,
			}).toString()}
		>
			<div className={cn(`site-grid`, {
				'mb-64': index === 0
			})}>
				<div className="col-span-full md:col-span-9">
					<div className="font-400 text-4xl leading-100 text-black dark:text-white [&_strong]:font-500 [&_strong]:text-grey [&_strong]:dark:text-grey-dark prose mobile:text-balance">
						<RichText content={text} />
					</div>
				</div>
			</div>
		</div>
	)
}